export const states = {
    config: window.EPF_CONFIG || {},
    kundenportal: window.EPF_KUNDENPORTAL || false,

    paginationApi: window.EPF_PAGINATION_API || '',
    stockApi: window.EPF_STOCK_API || '', // fetch(window.EPF_STOCK_API+'&tx_epim_efapi[num]=10&tx_epim_efapi[article]=34590484')
    freeze: false,

    showFilters: true,

    selectedFilterValues: (() => {
        const selection = {};
        if (Array.isArray(window.EPF_INITIAL.selected)) {
            window.EPF_INITIAL.selected.forEach((s => {
                selection[s.name] = s.value;
            }))
        }
        return selection;
    })(),
    availableFilterValues: window.EPF_INITIAL.available,
    results: window.EPF_INITIAL.entities,
    totalResults: window.EPF_INITIAL.total
};
